import "./index.scss";
import { Formik } from "formik";

function ModalPackage({
  setStep,
  productsValues,
  setProductsValues,
  editMode,
  closeModal,
  step,
}) {
  return (
    <div className="product-modal-container">
      <div className="product-modal-header">
        <span className="title-txt">
          {editMode ? "Edit Package " : "Ajouter Package"}
        </span>
        <i
          className="bx bx-x"
          style={{ fontSize: 22, fontWeight: 700 }}
          onClick={() => closeModal()}
        ></i>
      </div>

      <div className="product-modal-body">
        <Formik
          initialValues={productsValues}
          validate={(values) => {
            const errors: any = {};
            if (!values.name) {
              errors.name = "Required";
            }

            if (!values.description) {
              errors.description = "Required *";
            }
            if (!values.price) {
              errors.price = "Required *";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              setProductsValues(values);
              setStep("second");
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue, // Add setFieldValue from Formik
          }) => (
            <form
              className="form-container"
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
              onSubmit={handleSubmit}
            >
              <div className="modal-inputs-row">
                <div className="input-title-container">
                  <span className="title-name-txt">Package Name</span>
                  <input
                    name="name"
                    className="input-name-style"
                    type="text"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="package name"
                  />
                  <>{errors.name && touched.name && errors.name}</>
                </div>
                <div className="input-title-container">
                  <span className="title-name-txt">Description</span>
                  <input
                    name="description"
                    className="input-description-style"
                    type="text"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="description ..."
                  />
                  <>
                    {errors.description &&
                      touched.description &&
                      errors.description}
                  </>
                </div>
              </div>
              <div className="modal-inputs-row">
                <div className="input-title-container">
                  <span className="title-name-txt">Price</span>
                  <input
                    name="price"
                    className="input-name-style"
                    type="number"
                    value={values.price}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="price $"
                  />
                  <>{errors.price && touched.price && errors.price}</>
                </div>
                <div className="input-title-container">
                  <span className="title-name-txt">Solde</span>
                  <input
                    name="sold"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.sold}
                    className="input-name-style"
                    type="number"
                    placeholder="sold %"
                  />
                  <>{errors.sold && touched.sold && errors.sold}</>
                </div>
              </div>

              <div className="product-modal-footer">
                <div className="bulls-container">
                  <div className="bull-1" />
                  <div className="bull-2" />
                  <div className="bull-2" />
                </div>
                <button
                  type="submit"
                  className="btn-next"
                  style={{ backgroundColor: "#1ea182", color: "#fff" }}
                >
                  Next <i className="bx bx-chevron-right"></i>
                </button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ModalPackage;
